import type { StoredRuleSet } from "../engine/types";
import cancer from "./compiled/cancer.json";
import alzheimers from "./compiled/alzheimers.json";
import stroke from "./compiled/stroke.json";
import copd from "./compiled/copd.json";
import chf from "./compiled/chf.json";
import neurologic from "./compiled/neurologic.json";
import huntingtons from "./compiled/huntingtons.json";
import mdIbm from "./compiled/md-ibm.json";
import myasthenia from "./compiled/myasthenia.json";
import renal from "./compiled/renal.json";
import liver from "./compiled/liver.json";
import hiv from "./compiled/hiv.json";

// Single source of truth for the diagnosis rule sets, consumed by both the app
// (main.ts) and the i18n validator, so a new pathway is never registered in one
// place but missed in the other.
export const ruleSets: Record<string, StoredRuleSet> = {
  cancer: cancer as unknown as StoredRuleSet,
  alzheimers: alzheimers as unknown as StoredRuleSet,
  stroke: stroke as unknown as StoredRuleSet,
  copd: copd as unknown as StoredRuleSet,
  chf: chf as unknown as StoredRuleSet,
  neurologic: neurologic as unknown as StoredRuleSet,
  huntingtons: huntingtons as unknown as StoredRuleSet,
  "md-ibm": mdIbm as unknown as StoredRuleSet,
  myasthenia: myasthenia as unknown as StoredRuleSet,
  renal: renal as unknown as StoredRuleSet,
  liver: liver as unknown as StoredRuleSet,
  hiv: hiv as unknown as StoredRuleSet,
};
